import React, { useState, useEffect } from "react";
import "../../css/freelancer-dashboard.css";
import { getFreelancerLeadStats } from "../../services/leadsService";
import JobCard from "../../components/dashboard/JobCard";

const FreelancerDashboard = () => {
  const [stats, setStats] = useState({
    accepted: 0,
    pending: 0,
    total_interests: 0,
    liked: 0,
    jobs: [],
  });

  const [isLoading, setIsLoading] = useState(true);

  const [activeTab, setActiveTab] = useState("accepted"); // Default tab

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await getFreelancerLeadStats();
        setStats(data);
      } catch (err) {
        console.error("Error loading stats:", err);
      } finally {
        setIsLoading(false); // <-- done loading
      }
    };

    fetchStats();
  }, []);

  const cards = [
    {
      key: "accepted",
      value: stats.jobs.filter(j => j.job_status === "active" && j.lead_status === "accepted").length,
      title: "Active Leads",
      description: "Accepted and still active"
    },
    { key: "pending", value: stats.pending, title: "Pending Interests", description: "Interest requests waiting for client review" },
    { key: "total_interests", value: stats.total_interests, title: "Total Interests Sent", description: "Total interests sent" },
    { key: "liked", value: stats.total_likes, title: "Liked", description: "Service requests liked" }
  ];

  // Filter jobs based on active tab
  const filteredJobs = (() => {
    if (activeTab === "total_interests") return stats.jobs;
    if (activeTab === "liked") return stats.liked_jobs || [];
    if (activeTab === "accepted") {
      return stats.jobs.filter(job => job.job_status === "active" && job.lead_status === "accepted");
    }
    if (activeTab === "pending") {
      return stats.jobs.filter(job => job.job_status === "active" && job.lead_status === "pending");
    }
    return [];
  })();

  if (isLoading) return null;

  return (
    <div className="freelancer-dashboard">
      <div className="freelancer-dashboard-grid">
        {cards.map(card => {
          const isActive = activeTab === card.key;
          return (
            <div
              key={card.key}
              className={`freelancer-card ${isActive ? "active" : ""}`}
              onClick={() => setActiveTab(card.key)}
            >
              <h3>{card.value}</h3>
              <p
                className="freelancer-card-title"
              >
                {card.title}
              </p>
              <p className="freelancer-card-description">({card.description})</p>
            </div>
          );
        })}
      </div>

      <div className="freelancer-tab-content">
        {filteredJobs.length ? (
          filteredJobs.map(job => <JobCard key={job.id} job={job} />)
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
};

export default FreelancerDashboard;